import { useEffect, useState } from "react";

import { ReviewData } from "@/types/renewals";

import { fetchAverageRating } from "../api/trustpilot/trustpilot";

const useTrustPilotReviewData = (brandName: string) => {
  const [reviewData, setReviewData] = useState<ReviewData>({
    stars: 0,
    score: 0,
    totalReviews: "",
    link: {
      herf: "",
    },
  });
  useEffect(() => {
    const fetchRatingData = async () => {
      fetchAverageRating(brandName as string)
        .then((res) => {
          setReviewData(res);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log(
            "[TrustpilotBlock]: No Trustpilot data found. Skip rendering."
          );
        });
    };

    if (!brandName) return;
    fetchRatingData();
  }, [brandName]);

  return {
    reviewData,
  };
};

export default useTrustPilotReviewData;
